var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.types,"name":_vm.name,"label":_vm.label,"hide-details":""},model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }